/* Facets use the exact current Shopify search, not a download of the shop. */
(() => {
  const C=window.AutoDiazCatalog;if(!C || C.searchCatalog)return;
  const requests=new Map(),TTL=60000;
  const entities={quot:'"',apos:"'",amp:'&',lt:'<',gt:'>'};
  function matchesQuery(value,query) {
    if(typeof value!=='string')return false;
    if(value===query)return true;
    // Shopify's search.terms JSON retains HTML entities, while the HTML
    // attribute has already been decoded by the browser. Accept one escaped
    // serialization of the exact query, without rewriting literal user input.
    return value.replace(/&(?:quot|apos|amp|lt|gt|#0*(?:34|39|38|60|62)|#x0*(?:22|27|26|3c|3e));/gi,entity=>{
      const name=entity.slice(1,-1).toLowerCase();
      return name[0]==='#'?String.fromCharCode(name[1]==='x'?parseInt(name.slice(2),16):parseInt(name.slice(1),10)):entities[name];
    })===query;
  }
  function read(source,query,page) {
    const el=new DOMParser().parseFromString(String(source),'text/html').querySelector('[data-ad-search-data]');
    if(!el)throw Error('Search data unavailable');
    const data=JSON.parse(el.textContent);
    if(data.version!==1 || !matchesQuery(data.query,query) || !Array.isArray(data.types) || data.types.length!==1 || data.types[0]!=='product' ||
      !Number.isInteger(data.page) || data.page!==page || !Number.isInteger(data.count) || data.count<0 || data.count>25000 ||
      !Number.isInteger(data.page_size) || data.page_size<1 || data.page_size>250 || !Number.isInteger(data.pages) || (data.count?data.pages!==Math.ceil(data.count/data.page_size):![0,1].includes(data.pages)) || !/^[A-Z]{3}$/.test(data.currency || '') ||
      !Array.isArray(data.products) || data.products.length!==Math.max(0,Math.min(data.page_size,data.count-(page-1)*data.page_size)) ||
      data.products.some(p=>p.id==null || !p.handle || typeof p.title!=='string' || !Array.isArray(p.variants) || !p.variants.length) ||
      new Set(data.products.map(p=>String(p.id))).size!==data.products.length)throw Error('Incomplete search data');
    return data;
  }
  C.searchCatalog=function(query,options={}) {
    query=String(query || '');
    const params=new URLSearchParams(location.search),searchOptions=new URLSearchParams();
    for(const name of ['sort_by','options[prefix]','options[unavailable_products]'])if(params.has(name))searchOptions.set(name,params.get(name));
    const key=[location.origin,C.url('search').pathname,query,searchOptions.toString(),params.get('preview_theme_id') || '',document.documentElement.lang,window.Shopify?.country || '',C.readConfig()?.currency || ''].join('|');
    const subscribe=entry=>{
      if(typeof options.onProgress==='function'){entry.listeners.add(options.onProgress);if(entry.latest)try{options.onProgress(entry.latest);}catch{}}
      return entry.promise.finally(()=>entry.listeners.delete(options.onProgress));
    };
    const saved=requests.get(key);if(saved?.until>Date.now())return subscribe(saved);
    const entry={until:Date.now()+TTL,listeners:new Set(),latest:null};
    const progress=data=>{entry.latest=data;for(const fn of entry.listeners)try{fn(data);}catch{}};
    entry.promise=(async()=>{
      let first=null;
      // A bookmarked native facet is translated into a local facet, so its
      // already-filtered server feed cannot become the complete base selection.
      if(![...params.keys()].some(k=>k.startsWith('filter.')))for(const el of document.querySelectorAll('[data-ad-search-data]')){
        try{const page=JSON.parse(el.textContent).page;first=read(el.outerHTML,query,page);break;}catch{/* Fetch a fresh bounded search instead. */}
      }
      const fetchPage=async(page,stable=false,signal)=>{
        const u=C.url('search');u.searchParams.set('q',query);u.searchParams.set('type','product');u.searchParams.set('options[prefix]','last');
        for(const [name,value]of searchOptions)u.searchParams.set(name,value);
        if(stable)u.searchParams.set('sort_by','price-ascending');
        u.searchParams.set('section_id','autodiaz-search-data');u.searchParams.set('page',String(page));
        return read(await C.readText(u,signal),query,page);
      };
      if(!first)first=await fetchPage(1);
      let displayed=[];
      const unique=products=>[...new Map(products.map(p=>[String(p.id),p])).values()];
      const load=async(stable=false)=>{
        const batch=new AbortController(),initial=stable?await fetchPage(1,true,batch.signal):first,pages=new Map([[initial.page,initial]]),receivedIds=new Set(initial.products.map(p=>String(p.id)));
        let active=true;
        const invalid=message=>{active=false;batch.abort();throw Error(message);};
        const arrange=products=>{
          const fresh=new Map(products.map(p=>[String(p.id),p]));
          return unique(stable?displayed.map(p=>fresh.get(String(p.id)) || p).concat(products):products).slice(0,initial.count).map((p,i)=>({...p,_searchOrder:i}));
        };
        const result=(products,complete)=>({products:arrange(products),currency:initial.currency,complete,limited:initial.count===1000,source:'search',query,...(stable?{recovered:true}:{})});
        const publish=()=>{
          if(!active || !pages.has(1))return;
          const ordered=[];for(let page=1;pages.has(page);page++)ordered.push(pages.get(page));
          const products=ordered.flatMap(data=>data.products);
          if(!stable)displayed=unique(products);
          progress(result(products,false));
        };
        publish();
        const pending=Array.from({length:initial.pages},(_,i)=>i+1).filter(page=>!pages.has(page));let next=0;
        try {
          await Promise.all(Array.from({length:Math.min(3,pending.length)},async()=>{
            while(active && next<pending.length){const page=pending[next++],data=await fetchPage(page,stable,batch.signal);
              if(!active)return;
              if(data.count!==initial.count || data.pages!==initial.pages || data.page_size!==initial.page_size || data.currency!==initial.currency)invalid('Search changed while loading');
              if(data.products.some(p=>receivedIds.has(String(p.id))))invalid('Incomplete search selection');
              data.products.forEach(p=>receivedIds.add(String(p.id)));
              pages.set(page,data);publish();
            }
          }));
          const products=[...pages.entries()].sort((a,b)=>a[0]-b[0]).flatMap(([,d])=>d.products),ids=new Set(products.map(p=>String(p.id)));
          if(products.length!==initial.count || ids.size!==initial.count)throw Error('Incomplete search selection');
          if(stable && initial.count!==1000 && displayed.some(p=>!ids.has(String(p.id))))throw Error('Search selection changed while loading');
          return result(products,true);
        }catch(error){active=false;batch.abort();throw error;}
      };
      let data;
      try{data=await load();}
      catch(error){
        // Shopify can repeat an ID at a relevance-page boundary. Retry this
        // bounded search once with a stable order, retaining the earlier cards.
        if(first.pages<=1 || !/^(?:Incomplete search selection|Search changed while loading)$/.test(error.message))throw error;
        data=await load(true);
      }
      entry.latest=null;entry.until=Date.now()+TTL;return data;
    })().catch(error=>{requests.delete(key);throw error;});
    requests.set(key,entry);return subscribe(entry);
  };
})();
